import React from "react";
import { Heart, Briefcase, Sparkles, Gift, Users, Calendar } from "lucide-react";
import PageHero from "../components/blocks/PageHero";
import Section from "../components/ui/Section";
import PremiumButton from "../components/ui/PremiumButton";
import mockData from "../mockData";
import useSEO from "../hooks/useSEO";

const iconMap = {
  Heart,
  Briefcase,
  Sparkles,
  Gift,
};

const Events = () => {
  useSEO('/events');
  
  return (
    <div className="min-h-screen bg-[#050706] text-[#F4F1E8] pt-16">
      <PageHero
        title="Events"
        subtitle="Celebrate life in the forest"
        image="https://images.unsplash.com/photo-1520975916090-3105956dac38?auto=format&fit=crop&w=2400&q=80"
      />

      <Section className="py-16">
        <h2 className="text-3xl md:text-4xl font-light text-white">
          Your special moments, our sacred space
        </h2>
        <p className="mt-4 max-w-3xl text-sm md:text-base text-white/70 leading-relaxed">
          From intimate celebrations to small team offsites — the forest makes everything feel more
          meaningful. Share your dates and guest count; we'll respond with clear options.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {mockData.events.map((event) => {
            const Icon = iconMap[event.icon];
            return (
              <div
                key={event.id}
                className="rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-md hover:border-[#C9A227]/30 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="rounded-2xl border border-white/10 bg-black/25 p-3">
                    {Icon ? <Icon size={22} className="text-[#C9A227]" /> : null}
                  </div>
                  <div className="flex-1">
                    <div className="text-xl font-semibold text-white">{event.title}</div>
                    <div className="mt-1 inline-flex items-center gap-2 text-xs text-white/60">
                      <Users size={14} /> {event.capacity}
                    </div>
                    <p className="mt-3 text-sm text-white/70 leading-relaxed">{event.description}</p>
                  </div>
                </div>

                <div className="mt-6">
                  <PremiumButton href="/contact" variant="secondary" className="w-full justify-center">
                    <span className="inline-flex items-center gap-2">
                      <Calendar size={16} /> Enquire
                    </span>
                  </PremiumButton>
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
};

export default Events;
